import fetchAdditionalJobData from './parallelized/fetchAdditionalJobData';
import fetchGdprTexts from './parallelized/fetchGdprTexts';
import fetchProfile from './parallelized/fetchProfile';
import fetchCustomFields from './parallelized/customFields';

/**
 * Execute BFF calls in parallel instead of sequentially for
 * performance gains, but still wait for all to finish.
 */
export async function concurrentBffCalls() {
    const parallelBffCalls = [
        fetchCustomFields(),
        fetchAdditionalJobData(),
        fetchGdprTexts(),
        fetchProfile(),
    ];

    await Promise.all(parallelBffCalls);
}
